module.exports = __webpack_public_path__ + "img/juxueIcon5.9c75340a.png";